/* Chuyển phiếu báo giá sang POS: ghi dịch vụ của phiếu lên lịch hẹn trên hệ thống — quầy POS mở lịch hẹn là có sẵn giỏ */
import { updatePosAppointmentServices } from '../../api/PosV2';
import { explainPosError } from '../POS/remote';
import { paidOf, vnd, type OfficialQuote, type Visit } from './logic';

/**
 * Dòng gửi POS (chỉ dịch vụ lẻ): giá niêm yết; chiết khấu / đơn vị = giảm % phiếu (dịch vụ không chủ lực) hoặc cả giá (tặng kèm).
 * Thẻ liệu trình không nằm trong giỏ lịch hẹn — quầy bán thẻ ở POS theo ghi chú (đơn POS có dòng gói, server phát hành thẻ).
 */
export const posItems = (q: OfficialQuote) => q.lines.filter((l) => !l.card).map((l) => ({
  service_id: l.apiId!,
  quantity: Math.max(1, l.qty),
  price: l.price,
  discount: l.gift ? l.price : l.core ? 0 : Math.round((l.price * q.discount) / 100),
  staff_id: null,
}));

/** "Bán thẻ GOI-HIFU5 Gói Hifu 5 buổi × 1 (60.000.000 đ)" — ghi chú để quầy POS bán đúng thẻ */
export const posCardNote = (q: OfficialQuote) => q.lines.filter((l) => l.card)
  .map((l) => `Bán thẻ ${l.card!.code} ${l.name} × ${l.qty} (${vnd(l.qty * l.price)})`).join('; ');

/** Vì sao chưa chuyển được (undefined = chuyển được) */
export function posBlock(v: Visit): string | undefined {
  if (!v.quote) return 'Chưa có phiếu báo giá chính thức.';
  if (!v.apiApptId) return 'Lượt này không có lịch hẹn trên hệ thống — quầy POS tạo đơn khách lẻ theo phiếu.';
  const svcs = v.quote.lines.filter((l) => !l.card);
  if (!svcs.length) return 'Phiếu chỉ có thẻ liệu trình — quầy POS bán thẻ theo phiếu (Thẻ liệu trình › Bán thẻ).';
  if (svcs.some((l) => !l.apiId)) return 'Phiếu có dịch vụ lấy từ bảng giá mẫu — đổi sang dịch vụ trong danh mục hệ thống rồi chuyển lại.';
  return undefined;
}

/** Ghi giỏ của phiếu lên lịch hẹn; cọc, VAT và thẻ liệu trình cần bán ghi vào ghi chú để quầy đối chiếu */
export async function pushQuoteToPos(v: Visit): Promise<{ ok: true } | { ok: false; error: string }> {
  const why = posBlock(v);
  if (why) return { ok: false, error: why };
  const q = v.quote!;
  const paid = paidOf(v);
  const note = [`Phiếu báo giá ${q.code}`, paid ? `đã cọc ${vnd(paid)}` : '', q.vat ? `VAT ${q.vat}%` : '', posCardNote(q)].filter(Boolean).join(' · ');
  const res = await updatePosAppointmentServices(v.apiApptId!, { items: posItems(q), note });
  return res.ok ? { ok: true } : { ok: false, error: explainPosError(res, 'Không ghi được giỏ lên lịch hẹn') };
}
